"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DynamicSubmitButton = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.replace.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.object.get-prototype-of.js");
var _react = _interopRequireDefault(require("react"));
var _lodash = _interopRequireDefault(require("lodash"));
var _semanticUiReact = require("semantic-ui-react");
var _utils = require("../../common/utils");
var _ButtonField = _interopRequireDefault(require("../../go/components/common/form/ButtonField"));
var _FemaGoModal = _interopRequireDefault(require("../../go/components/common/modal/FemaGoModal"));
var _contentDispatch = require("../../framework/components/contentDispatch");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var DynamicSubmitButton = /*#__PURE__*/function (_React$Component) {
  _inherits(DynamicSubmitButton, _React$Component);
  var _super = _createSuper(DynamicSubmitButton);
  function DynamicSubmitButton() {
    var _this;
    _classCallCheck(this, DynamicSubmitButton);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      isConfirmationModalOpen: false,
      lockingData: false
    };
    _this.handleSubmit = function () {
      var _this$props = _this.props,
        config = _this$props.config,
        data = _this$props.data,
        dynamicComponent = _this$props.dynamicComponent,
        handlePostSubmit = _this$props.handlePostSubmit;
      var submissionConfiguration = config.submit;
      var payload = _this.createPayload(submissionConfiguration, data, dynamicComponent);
      _this.props.handleSubmit(payload).then(function (res) {
        if (handlePostSubmit && _lodash.default.isEmpty(res.errors) && _lodash.default.get(res, 'status', _lodash.default.get(res, 'meta.status')) === 200) {
          handlePostSubmit(res);
        }
      });
    };
    _this.handleClick = function (payload) {
      var enableModalOnApprove = _lodash.default.get(_this.props, 'enableModalOnApprove', false);
      var determnationApproved = _this.props.determination === 'Approve' || _this.props.determination === 'Sign' ? true : false;
      if (_this.props.confirmSubmission) {
        // show confirmation modal Only when detrmination is Approve or Sign
        if (enableModalOnApprove && !determnationApproved) {
          return _this.submissionLockEntity();
        }
        // Show modal
        _this.setState({
          isConfirmationModalOpen: true,
          payload: payload // is this needed?
        });
      } else {
        return _this.submissionLockEntity();
      }
    };
    _this.submissionLockEntity = function () {
      var _this$props2 = _this.props,
        currentlyCollaborating = _this$props2.currentlyCollaborating,
        handleSubmissionLock = _this$props2.handleSubmissionLock;
      //If we arent CE continue with normal callback
      if (!currentlyCollaborating) {
        return _this.handleSubmit();
      }
      _this.setState({
        lockingData: true
      });
      handleSubmissionLock();
    };
    _this.render = function () {
      var _this$props3 = _this.props,
        displayError = _this$props3.displayError,
        name = _this$props3.name,
        label = _this$props3.label,
        optional = _this$props3.optional,
        handleBlur = _this$props3.handleBlur,
        value = _this$props3.value,
        errorMessages = _this$props3.errorMessages,
        hintText = _this$props3.hintText,
        size = _this$props3.size,
        id = _this$props3.id,
        type = _this$props3.type,
        sections = _this$props3.sections,
        disableOnSections = _this$props3.disableOnSections,
        disableOnValidationErrors = _this$props3.disableOnValidationErrors,
        allowSubmitIf = _this$props3.allowSubmitIf,
        validationErrors = _this$props3.validationErrors,
        disableText = _this$props3.disableText,
        basic = _this$props3.basic,
        savingData = _this$props3.savingData,
        evaluateOperator = _this$props3.evaluateOperator;
      var isDisabled = _this.props.isDisabled;
      var lockingData = _this.state.lockingData;
      var popupText = isDisabled ? disableText : '';
      var submitShortcut = false;
      var shortcutSections = [];

      /**
       * disableText is mostly used for the password + confirmation box text
       * ignore disableOnSections and allowSubmitIf for new pages
       * disableOnValidationErrors: [
       *    {
       *      "paths": ["path.from.dynamicComponent.validationErrors", "second.path.from.dynamicComponent.validationErrors"],
       *      "displayName": "My error to put in the popup"
       *    },
       *    {
       *      "path": "another.path.from.dynamicComponent.validationErrors",
       *      "displayName": "My error to put in the popup"
       *    }
       * ]
       **/

      // DEPRECATED BY disableOnValidationErrors below
      if (allowSubmitIf) {
        _lodash.default.forEach(allowSubmitIf, function (config) {
          var propsPath = config.propsPath,
            value = config.value,
            operator = config.operator;
          var propValue = _lodash.default.get(_this.props, propsPath);
          if (evaluateOperator(operator, propValue, value)) {
            submitShortcut = true;
            shortcutSections = config.stillDisableOnSections;
          }
        });
      }
      // USE ONLY FOR REVIEW PANEL FLYOUT, should be reworked to just disable based on all validation errors once ReviewPanel2018 is no longer used
      if (disableOnSections) {
        _lodash.default.forEach(sections, function (section) {
          if (section.status && section.status === 'incomplete') {
            if (submitShortcut && !shortcutSections.includes(section.id)) isDisabled = false;else {
              isDisabled = true;
              popupText += " ".concat(section.name, ",");
            }
          }
        });
      }
      if (disableOnValidationErrors) {
        if (!_lodash.default.isEmpty(disableOnValidationErrors) && _lodash.default.get(validationErrors, 'isLoading')) {
          // isDisabled = true;
          popupText = 'Validating your responses...';
        }
        var updatePopup = function updatePopup(path, displayName, popupText, uniquePopUpTexts) {
          var validationResult = _lodash.default.get(validationErrors, "errors.".concat(path));
          var isValid = validationResult;
          if (_lodash.default.isArray(validationResult)) {
            _lodash.default.forEach(validationResult, function (res) {
              isValid = isValid && _lodash.default.get(res, 'isValid', false);
            });
          }
          if (!isValid) {
            isDisabled = true;
            if (_lodash.default.find(uniquePopUpTexts, function (text) {
              return _lodash.default.isEqual(text, displayName);
            }) === undefined) {
              uniquePopUpTexts.push(displayName);
              popupText += displayName !== undefined ? " ".concat(displayName, ".") : '';
            }
          }
          return popupText;
        };
        _lodash.default.forEach(disableOnValidationErrors, function (entry) {
          var uniquePopUpTexts = [popupText];
          if (_lodash.default.isArray(entry.paths)) {
            _lodash.default.forEach(entry.paths, function (path) {
              return popupText = updatePopup(path, entry.displayName, popupText, uniquePopUpTexts);
            });
          } else {
            popupText = updatePopup(entry.path, entry.displayName, popupText, uniquePopUpTexts);
          }
        });
      }
      if (!_lodash.default.isEmpty(_this.props.disableOnAnyError)) {
        if (validationErrors.isLoading) {
          popupText = 'Validating your responses....';
        }
        if (!validationErrors.allValid) {
          isDisabled = true;
          popupText = _this.props.disableOnAnyError;
        }
      }
      popupText = popupText.replace(/.$/, '');
      var button = /*#__PURE__*/_react.default.createElement(_ButtonField.default, {
        question: _this.props.config.guidance,
        buttonText: _this.props.config.submitButtonLabel,
        handleClick: _this.handleClick,
        color: "blue",
        name: name,
        displayError: displayError,
        label: label,
        optional: optional,
        handleBlur: handleBlur,
        value: value,
        errorMessages: errorMessages,
        hintText: hintText,
        id: id,
        type: type,
        size: size,
        isDisabled: isDisabled || savingData || lockingData,
        basic: basic
      });
      if (isDisabled || savingData) button = /*#__PURE__*/_react.default.createElement(_semanticUiReact.Popup, {
        trigger: /*#__PURE__*/_react.default.createElement("span", null, button),
        on: ['hover', 'focus'],
        content: isDisabled ? popupText : 'Saving...',
        wide: "very"
      });
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, button, _this.renderModal());
    };
    return _this;
  }
  _createClass(DynamicSubmitButton, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props4 = this.props,
        isEntityLocked = _this$props4.isEntityLocked,
        whoLockedEntity = _this$props4.whoLockedEntity,
        context = _this$props4.context;
      // When a CE submission lock is triggered, we wait for the lock info before continiung with submission
      if (this.state.lockingData && !_lodash.default.isEqual(_lodash.default.get(prevProps, 'isEntityLocked'), isEntityLocked) && isEntityLocked && _lodash.default.isEqual(context.auth.userId, whoLockedEntity)) {
        this.setState({
          lockingData: false
        });
        this.handleSubmit();
      }
    }
  }, {
    key: "renderModal",
    value: function renderModal() {
      var _this2 = this;
      var _this$state = this.state,
        isConfirmationModalOpen = _this$state.isConfirmationModalOpen,
        payload = _this$state.payload;
      var _this$props5 = this.props,
        confirmationModal = _this$props5.confirmationModal,
        contentMap = _this$props5.contentMap;
      var submissionVariables = _lodash.default.get(this.props, 'submissionVariables', {});
      var modalConfig = confirmationModal || {};
      var modalTitle = _lodash.default.get(modalConfig, 'modalTitle', '');
      var buttonText = _lodash.default.get(modalConfig, 'buttonText', 'Confirm');
      var cancelButtonText = _lodash.default.get(modalConfig, 'cancelButtonText', 'Cancel');
      var modalContent = (0, _utils.compileContent)(_lodash.default.get(modalConfig, 'modalContent', ''), _objectSpread(_objectSpread({}, this.props), submissionVariables));
      var contents = _lodash.default.get(modalConfig, 'contents', []);
      return /*#__PURE__*/_react.default.createElement(_FemaGoModal.default, {
        title: modalTitle,
        buttonText: buttonText,
        cancelButtonText: cancelButtonText,
        open: !!isConfirmationModalOpen,
        confirmAction: function confirmAction() {
          _this2.setState({
            isConfirmationModalOpen: false
          });
          _this2.submissionLockEntity();
        },
        cancelAction: function cancelAction() {
          return _this2.setState({
            isConfirmationModalOpen: false
          });
        },
        htmlContent: modalContent
      }, _lodash.default.map(contents, function (conf, index) {
        var config = _objectSpread({}, conf);
        return /*#__PURE__*/_react.default.createElement(_contentDispatch.ContentDispatch, {
          contentMap: contentMap,
          key: conf.id || index,
          config: config
        });
      }));
    }
  }, {
    key: "createPayload",
    value: function createPayload(submissionConfiguration, formData, dynamicComponent) {
      var _this3 = this;
      var getValue = function getValue(field) {
        var value;
        if (field.propsPath !== undefined) {
          // requires dependencies passed in as props (via config or parent component)
          value = _lodash.default.get(_this3.props, field.propsPath);
        } else if (field.fieldPath !== undefined) {
          // deprecated in favor of propsPath (uses dynamicComponent instead of framework to gather dependencies)
          value = _lodash.default.get(formData, field.fieldPath);
          value = value === undefined ? _lodash.default.get(dynamicComponent, field.fieldPath) : value;
        }
        value = value === undefined ? field.defaultValue : value;
        return value;
      };
      var payload = {};
      if (_lodash.default.get(submissionConfiguration, 'data')) {
        submissionConfiguration.data.forEach(function (field) {
          var value = getValue(field);
          return payload[field.fieldName] = value;
        });
      }
      if (_lodash.default.get(submissionConfiguration, 'transformData')) {
        submissionConfiguration.transformData.forEach(function (field) {
          var value = getValue(field);
          payload[field.fieldName] = _this3.transformData(field.transform, value, _this3.props);
        });
      }
      return payload;
    }
  }, {
    key: "transformData",
    value: function transformData(transform, conditionalField, props) {
      switch (transform.type) {
        // set the value at that key's value
        case 'map':
          return transform.map[conditionalField];
        // set the data at the datapath defined by the key's value
        case 'dataMap':
          return _lodash.default.get(props, transform.map[conditionalField]);
        // set the value directly
        case 'value':
          return transform.value;
        default:
          return conditionalField;
      }
    }
  }]);
  return DynamicSubmitButton;
}(_react.default.Component);
exports.DynamicSubmitButton = DynamicSubmitButton;